<!-- Mobile nav bar -->
<div class="mobile-nav-bar" (click)="mobileNavOpen = true" role="button" aria-label="Open menu" tabindex="0" (keydown.enter)="mobileNavOpen = true" (keydown.space)="mobileNavOpen = true">
  <span class="mobile-nav-label">{{ activeTabLabel }}</span>
  <button class="hamburger-btn" (click)="$event.stopPropagation(); mobileNavOpen = !mobileNavOpen" [class.open]="mobileNavOpen" aria-label="Toggle menu">
    <span></span><span></span><span></span>
  </button>
</div>
<div class="mobile-nav-overlay" *ngIf="mobileNavOpen" (click)="mobileNavOpen = false"></div>
<div class="mobile-nav-dropdown" [class.open]="mobileNavOpen">
  <div class="mobile-nav-group">MY SHIP</div>
  <button class="mobile-nav-item" [class.active]="activeTab === 'overview'" (click)="onSelect('overview')">Overview</button>
  <button class="mobile-nav-item" [class.active]="activeTab === 'crew'" (click)="onSelect('crew')">Crew <span class="tab-badge">{{ crewCount }}</span></button>
  <button class="mobile-nav-item" [class.active]="activeTab === 'rooms'" (click)="onSelect('rooms')">Rooms <span class="tab-badge">{{ roomsCount }}</span></button>
  <button class="mobile-nav-item" [class.active]="activeTab === 'battles'" (click)="onSelect('battles')">Battles<span class="tab-badge" *ngIf="battlesCount > 0"> {{ battlesCount }}</span></button>
  <button class="mobile-nav-item" [class.active]="activeTab === 'friends'" (click)="onSelect('friends')">
    Friends
    <span class="friend-pending-dot" *ngIf="pendingFriendCount > 0" [attr.title]="pendingFriendCount + ' pending request(s)'" aria-label="pending friend requests"></span>
  </button>
  <button class="mobile-nav-item" [class.active]="activeTab === 'inventory'" (click)="onSelect('inventory')">Inventory</button>
  <ng-container *ngIf="hasGalaxy">
    <div class="mobile-nav-group">GALAXY</div>
    <button class="mobile-nav-item" [class.active]="activeTab === 'galaxy'" (click)="onSelect('galaxy')">Galaxy</button>
  </ng-container>
  <ng-container *ngIf="hasAlliance">
    <div class="mobile-nav-group">FLEET</div>
    <button class="mobile-nav-item" [class.active]="activeTab === 'fleet'" (click)="onSelect('fleet')">Members</button>
    <button class="mobile-nav-item" [class.active]="activeTab === 'fleet-chat'" (click)="onSelect('fleet-chat')">Chat</button>
    <button *ngIf="hasTournamentAnalysis" class="mobile-nav-item" [class.active]="activeTab === 'tournament'" (click)="onSelect('tournament')">Tournament</button>
  </ng-container>
  <div class="mobile-nav-group">DATA</div>
  <button class="mobile-nav-item" [disabled]="refreshing" (click)="mobileNavOpen = false; refreshClicked.emit()">
    <span [class.spin]="refreshing">&#x21BB;</span> Refresh
  </button>
</div>

<!-- Desktop nav (hidden on small screens) -->
<nav class="main-nav desktop-nav">
  <button class="main-nav-btn" [class.active]="mainSection === 'ship'" (click)="onSelect('overview')">My Ship</button>
  <button class="main-nav-btn" [class.active]="mainSection === 'galaxy'" (click)="onSelect('galaxy')"
          *ngIf="hasGalaxy">Galaxy</button>
  <button class="main-nav-btn" [class.active]="mainSection === 'fleet'" (click)="onSelect('fleet')"
          *ngIf="hasAlliance">Fleet</button>
  <button class="main-nav-btn refresh-btn" [disabled]="refreshing" (click)="refreshClicked.emit()" title="Refresh current tab data">
    <span [class.spin]="refreshing">&#x21BB;</span> Refresh
  </button>
</nav>

<!-- Sub-tab nav: My Ship -->
<nav class="tab-nav desktop-nav" *ngIf="mainSection === 'ship'">
  <button class="tab-btn" [class.active]="activeTab === 'overview'" (click)="onSelect('overview')">Overview</button>
  <button class="tab-btn" [class.active]="activeTab === 'crew'" (click)="onSelect('crew')">
    Crew <span class="tab-badge">{{ crewCount }}</span>
  </button>
  <button class="tab-btn" [class.active]="activeTab === 'rooms'" (click)="onSelect('rooms')">
    Rooms <span class="tab-badge">{{ roomsCount }}</span>
  </button>
  <button class="tab-btn" [class.active]="activeTab === 'battles'" (click)="onSelect('battles')">
    Battles<span class="tab-badge" *ngIf="battlesCount > 0">{{ battlesCount }}</span>
  </button>
  <button class="tab-btn" [class.active]="activeTab === 'friends'" (click)="onSelect('friends')">
    Friends
    <span class="friend-pending-dot" *ngIf="pendingFriendCount > 0" [attr.title]="pendingFriendCount + ' pending request(s)'" aria-label="pending friend requests"></span>
  </button>
  <button class="tab-btn" [class.active]="activeTab === 'inventory'" (click)="onSelect('inventory')">
    Inventory<span class="tab-badge" *ngIf="inventoryCount > 0">{{ inventoryCount }}</span>
  </button>
</nav>

<!-- Sub-tab nav: Fleet -->
<nav class="tab-nav desktop-nav" *ngIf="mainSection === 'fleet' && hasAlliance">
  <button class="tab-btn" [class.active]="activeTab === 'fleet'" (click)="onSelect('fleet')">Members</button>
  <button class="tab-btn" [class.active]="activeTab === 'fleet-chat'" (click)="onSelect('fleet-chat')">Chat</button>
  <button *ngIf="hasTournamentAnalysis" class="tab-btn" [class.active]="activeTab === 'tournament'" (click)="onSelect('tournament')">Tournament</button>
</nav>
